/**
 * Handles debouncing.
 */
export default class DebounceManager {
    constructor() {
        this.debounces = {};
    }
    /**
     * Sets a debounce.
     *
     * @param name Name.
     * @param callback Callback.
     * @param timeout Timeout.
     */
    set(name, callback, timeout = 0) {
        this.clear(name);
        this.debounces[name] = window.setTimeout(callback, timeout);
    }
    /**
     * Checks if a debounce exists.
     *
     * @param name Name of debounce.
     * @returns TRUE if debounce exists.
     */
    exists(name) {
        return typeof this.debounces[name] !== 'undefined';
    }
    /**
     * Clears a debounce.
     *
     * @param name Name of debounce.
     */
    clear(name) {
        clearTimeout(this.debounces[name]);
        delete this.debounces[name];
    }
    /**
     * Clears all debounces.
     */
    clearAll() {
        for (const name of Object.keys(this.debounces)) {
            this.clear(name);
        }
    }
}
//# sourceMappingURL=DebounceManager.js.map